
import * as commonTypes from '../services/strategicforcecastActionType';
import * as matrixservicerequest from '../matrixservicerequest/services/matrixservicerequestActionType';
import * as strategicCapsTypes from '../strategicCapsVsDemPlanner/services/strategicCapsVsDemandActionType';
import initialState from '../../../store/initialState';

const types = { ...commonTypes, ...matrixservicerequest, ...strategicCapsTypes }

const matrixserviceReducer = (state = initialState.matrixServiceRequest, action) => {

    //Get All Service Request Matrix Data
    switch (action.type) {

        case types.FETCH_MATRIXSERVICE_REQUST:
            return { ...state, isStrategicForecastLoading: true };
        case types.FETCH_MATRIXSERVICE_SUCCESS:
            return { ...state, isStrategicForecastLoading: false, strategicForecastData: action.payload?.values?.siteOnboardingPlannerlst || [] };
        case types.FETCH_MATRIXSERVICE_FAILURE:
            return { ...state, isStrategicForecastLoading: false };

        case types.SITEONBOARDINGPLANNER_DROPDOWN_VALUES_REQUEST:
            return { ...state, isallsiteonboardingplannerloading: true, siteonboardingplannerdata: [] };

        case types.SITEONBOARDINGPLANNER_DROPDOWN_VALUES_SUCCESS:
            return { ...state, isallsiteonboardingplannerloading: false, siteonboardingplannerdata: action.payload };

        case types.SITEONBOARDINGPLANNER_DROPDOWN_VALUES_FAILURE:
            return { ...state, isallsiteonboardingplannerloading: false, siteonboardingplannerdata: [] };


        case types.GETWORKLISTBY_RPCEID_REQUEST:
            return { ...state, isRPCEloading: true, RPCEDATA: [] };

        case types.GETWORKLISTBY_RPCEID_SUCCESS:
            return { ...state, isRPCEloading: false, RPCEDATA: action.payload };

        case types.GETWORKLISTBY_RPCEID_FAILURE:
            return { ...state, isRPCEloading: false, RPCEDATA: [] };

        case types.GETPRACTICENAMEBY_WORKLIST_REQUEST:
            return { ...state, isworklistLoading: true, WORKLISTDATA: [] };

        case types.GETPRACTICENAMEBY_WORKLIST_SUCCESS:
            return { ...state, isworklistLoading: false, WORKLISTDATA: action.payload };

        case types.GETPRACTICENAMEBY_WORKLIST_FAILURE:
            return { ...state, isworklistLoading: false, WORKLISTDATA: [] };

        case types.BULKSAVE_SERVICEREQUEST_REQUEST:
            return { ...state, ismatrixserviceSaving: true };

        case types.BULKSAVE_SERVICEREQUEST_SUCCESS:
            return { ...state, ismatrixserviceSaving: false };

        case types.BULKSAVE_SERVICEREQUEST_FAILURE:
            return { ...state, ismatrixserviceSaving: false };

        case types.DELETEMATRIXSERVICE_REQUEST:
            return { ...state, ismatrixservicedeleteLoading: true };
        case types.DELETEMATRIXSERVICE_SUCCESS:
            return { ...state, ismatrixservicedeleteLoading: false };
        case types.DELETEMATRIXSERVICE_FAILURE:
            return { ...state, ismatrixservicedeleteLoading: false };

        case types.EXPORT_MATRIXSERVICE_REQUEST:
            return { ...state, isStrategicForecastLoading: true };
        case types.EXPORT_MATRIXSERVICE_SUCCESS:
            return { ...state, isStrategicForecastLoading: false };
        case types.EXPORT_MATRIXSERVICE_FAILURE:
            return { ...state, isStrategicForecastLoading: false };

        case types.FETCH_ONBOARDING_SITE_DEMAND_PLANNER_REQUEST:
            return { ...state, isOnboardingSiteDemandPlannerLoading: true, OnboardingSiteDemandPlannerData: [] };
        case types.FETCH_ONBOARDING_SITE_DEMAND_PLANNER_SUCCESS:
            return { ...state, isOnboardingSiteDemandPlannerLoading: false, OnboardingSiteDemandPlannerData: action.payload?.siteOnboardingYearlyDemandPlannerlst || [] };
        case types.FETCH_ONBOARDING_SITE_DEMAND_PLANNER_FAILURE:
            return { ...state, isOnboardingSiteDemandPlannerLoading: false, OnboardingSiteDemandPlannerData: [] };

        case types.FETCH_ONBOARDING_SITE_DEMAND_PLANNER_LEGEND_LIST_REQUEST:
            return { ...state, isOnboardingSiteDemandPlannerLoading: true, OnboardingSiteDemandPlannerLegendListData: [] };
        case types.FETCH_ONBOARDING_SITE_DEMAND_PLANNER_LEGEND_LIST_SUCCESS:
            return { ...state, isOnboardingSiteDemandPlannerLoading: false, OnboardingSiteDemandPlannerLegendListData: action.payload?.siteOnboardingYearlyDemandPlannerLegendlst || [] };
        case types.FETCH_ONBOARDING_SITE_DEMAND_PLANNER_LEGEND_LIST_FAILURE:
            return { ...state, isOnboardingSiteDemandPlannerLoading: false, OnboardingSiteDemandPlannerLegendListData: [] };

        // Strategic Caps vs Demand - Notes Edit
        case types.FETCH_STRATEGIC_CAPS_NOTES_EDIT_REQUEST:
            return { ...state, isStrategicCapsLoading: true };
        case types.FETCH_STRATEGIC_CAPS_NOTES_EDIT_SUCCESS:
            return { ...state, isStrategicCapsLoading: false, notesEditData: action.payload?.values || '' };
        case types.FETCH_STRATEGIC_CAPS_NOTES_EDIT_FAILURE:
            return { ...state, isStrategicCapsLoading: false, notesEditData: '' };

        // Strategic Caps vs Demand - Notes Save
        case types.FETCH_STRATEGIC_CAPS_NOTES_SAVE_REQUEST:
            return { ...state, isStrategicCapsLoading: true };
        case types.FETCH_STRATEGIC_CAPS_NOTES_SAVE_SUCCESS:
            return { ...state, isStrategicCapsLoading: false, notesSaveSuccess: true };
        case types.FETCH_STRATEGIC_CAPS_NOTES_SAVE_FAILURE:
            return { ...state, isStrategicCapsLoading: false, notesSaveSuccess: false };

        // Strategic Caps vs Demand - Draft / Publish Actions
        case types.DRAFT_STRATEGIC_CAPS_REQUEST:
        case types.PUBLISH_STRATEGIC_CAPS_REQUEST:
            return { ...state, isStrategicCapsActionLoading: true };

        case types.DRAFT_STRATEGIC_CAPS_SUCCESS:
        case types.PUBLISH_STRATEGIC_CAPS_SUCCESS:
            return { ...state, isStrategicCapsActionLoading: false, strategicCapsActionSuccess: true };

        case types.DRAFT_STRATEGIC_CAPS_FAILURE:
        case types.PUBLISH_STRATEGIC_CAPS_FAILURE:
            return { ...state, isStrategicCapsActionLoading: false, strategicCapsActionSuccess: false };

        // Strategic Caps vs Demand - Delete Report
        case types.DELETE_STRATEGIC_CAPS_REPORT_REQUEST:
            return { ...state, isDeleteStrategicCapsLoading: true };
        case types.DELETE_STRATEGIC_CAPS_REPORT_SUCCESS:
            return { ...state, isDeleteStrategicCapsLoading: false};
        case types.DELETE_STRATEGIC_CAPS_REPORT_FAILURE:
            return { ...state, isDeleteStrategicCapsLoading: false};

        // Strategic Caps vs Demand - filter dropdown
        case types.FETCH_FILTER_STRATEGIC_CAPS_DROPDOWN_REQUEST:
            return { ...state, isFilterLoading: true };
        case types.FETCH_FILTER_STRATEGIC_CAPS_DROPDOWN_SUCCESS:
            return { ...state, isFilterLoading: false, filterDDList: action.payload?.values || [] };
        case types.FETCH_FILTER_STRATEGIC_CAPS_DROPDOWN_FAILURE:
            return { ...state, isFilterLoading: false, filterDDList: [] };
        
        // Strategic Caps vs Demand - Apply Filter
        case types.FETCH_FILTER_STRATEGIC_CAPS_APPLY_REQUEST:
            return { ...state, isStrategicCapsApplySuccess: null }; 
        case types.FETCH_FILTER_STRATEGIC_CAPS_APPLY_SUCCESS:
            return { ...state, isStrategicCapsApplySuccess: true };
        case types.FETCH_FILTER_STRATEGIC_CAPS_APPLY_FAILURE:
            return { ...state, isStrategicCapsApplySuccess: false };


        // Strategic Caps vs Demand - Export Report
        case types.EXPORT_STRATEGIC_CAPS_REPORT_REQUEST:
            return { ...state, isStrategicCapsLoading: true };
        case types.EXPORT_STRATEGIC_CAPS_REPORT_SUCCESS:
            return { ...state, isStrategicCapsLoading: false };
        case types.EXPORT_STRATEGIC_CAPS_REPORT_FAILURE:
            return { ...state, isStrategicCapsLoading: false };

        // Strategic Caps vs Demand - Reports
        case types.FETCH_STRATEGIC_CAPS_REPORTS_REQUEST:
            return { ...state, isStrategicCapsLoading: true };
        case types.FETCH_STRATEGIC_CAPS_REPORTS_SUCCESS:
            return { ...state, isStrategicCapsLoading: false, reportsData: action.payload?.values || [], totalRecords: action.payload?.recordsTotal || 0 };
        case types.FETCH_STRATEGIC_CAPS_REPORTS_FAILURE:
            return { ...state, isStrategicCapsLoading: false, reportsData: [], totalRecords: 0 };

        // GetBlockPlanningCapacityVsDemandTableReport - Reports
        case types.GET_STRATEGIC_CAPS_VS_DEMAND_REQUEST:
            return { ...state, isLoading: true };
        case types.GET_STRATEGIC_CAPS_VS_DEMAND_SUCCESS:
            return { ...state, isLoading: false, isStrategicCapsvsDemandData: action.payload?.values || [] };
        case types.GET_STRATEGIC_CAPS_VS_DEMAND_FAILURE:
            return { ...state, isLoading: false, isStrategicCapsvsDemandData: [] };

        // Get Worklist by RPCE id - Reports
        case types.GET_WORKLIST_BY_RPCEID_REQUEST:
            return { ...state, isStrategicCapsLoading: true };
        case types.GET_WORKLIST_BY_RPCEID_SUCCESS:
            return { ...state, isStrategicCapsLoading: false, selectedRPCEWorklist: action.payload?.values || [] };
        case types.GET_WORKLIST_BY_RPCEID_FAILURE:
            return { ...state, isStrategicCapsLoading: false, selectedRPCEWorklist: [] };

        // Strategic Caps vs Demand - Dropdown
        case types.FETCH_STRATEGIC_CAPS_DROPDOWN_REQUEST:
            return { ...state, isStrategicCapsLoading: true };
        case types.FETCH_STRATEGIC_CAPS_DROPDOWN_SUCCESS:
            return { ...state, isStrategicCapsLoading: false, dropdownData: action.payload?.values?.reportsDDList || [] };
        case types.FETCH_STRATEGIC_CAPS_DROPDOWN_FAILURE:
            return { ...state, isStrategicCapsLoading: false, dropdownData: [] };

        // Strategic Caps vs Demand - Week/Quarter dropdown (GetWeekQuarterByMonthYear)
        case types.FETCH_WEEK_QUARTER_CAPS_DROPDOWN_REQUEST:
            return { ...state, isStrategicCapsLoading: true };
        case types.FETCH_WEEK_QUARTER_CAPS_DROPDOWN_SUCCESS:
            return { ...state, isStrategicCapsLoading: false, weekQuarterData: action.payload?.values || {} };
        case types.FETCH_WEEK_QUARTER_CAPS_DROPDOWN_FAILURE:
            return { ...state, isStrategicCapsLoading: false, weekQuarterData: {} };

        // Strategic Caps vs Demand - wRVU Surplus Worklist View
        case types.FETCH_WRVU_SURPLUS_WORKLIST_REQUEST:
            return { ...state, isStrategicCapsLoading: true };
        case types.FETCH_WRVU_SURPLUS_WORKLIST_SUCCESS:
            return { ...state, isStrategicCapsLoading: false, wrvuSurplusWorklistData: action.payload?.values?.lstBlockCapacityVsDemandSurplusWorklistTable || [], wrvuSurplusWorklistTotalRecords: action.payload?.recordsTotal || 0 };
        case types.FETCH_WRVU_SURPLUS_WORKLIST_FAILURE:
            return { ...state, isStrategicCapsLoading: false, wrvuSurplusWorklistData: [], wrvuSurplusWorklistTotalRecords: 0 };

        // Strategic Caps vs Demand - wRVU Surplus View
        case types.FETCH_WRVU_SURPLUS_REQUEST:
            return { ...state, isStrategicCapsLoading: true };
        case types.FETCH_WRVU_SURPLUS_SUCCESS:
            return { ...state, isStrategicCapsLoading: false, wrvuSurplusData: action.payload?.values?.lstBlockCapacityVsDemandSurplusTable || [], wrvuSurplusTotalRecords: action.payload?.recordsTotal || 0 };
        case types.FETCH_WRVU_SURPLUS_FAILURE:
            return { ...state, isStrategicCapsLoading: false, wrvuSurplusData: [], wrvuSurplusTotalRecords: 0 };

        // Strategic Caps vs Demand - FTE Surplus View
        case types.FETCH_FTE_SURPLUS_REQUEST:
            return { ...state, isStrategicCapsLoading: true };
        case types.FETCH_FTE_SURPLUS_SUCCESS:
            return { ...state, isStrategicCapsLoading: false, fteSurplusData: action.payload?.values?.lstBlockCapacityVsDemandFTESurplusTable || [], fteSurplusTotalRecords: action.payload?.recordsTotal || 0 };
        case types.FETCH_FTE_SURPLUS_FAILURE:
            return { ...state, isStrategicCapsLoading: false, fteSurplusData: [], fteSurplusTotalRecords: 0 };

        // Strategic Caps vs Demand - Legend
        case types.FETCH_LEGEND_REQUEST:
            return { ...state };
case types.FETCH_LEGEND_SUCCESS:
    return {...state,legendData:action.payload?.values?.siteOnboardingYearlyDemandPlannerLegendlst || [],colorLegendData:action.payload?.values?.blockPlanningColorList || []};

        case types.FETCH_LEGEND_FAILURE:
            return { ...state, legendData: [] };

        // Strategic Caps vs Demand - Update Reducer
        case types.UPDATE_STRATEGIC_CAPS_REDUCER:
            return { ...state, ...action.payload };
    case types.FETCH_CAPS_DEMAND_FILTER_BY_ID_REQUEST:
      return { ...state, isCapsDemandFilterByIdLoading: true, capsDemandFilterByIdError: null, };

    case types.FETCH_CAPS_DEMAND_FILTER_BY_ID_SUCCESS:
      return { ...state, isCapsDemandFilterByIdLoading: false, capsDemandFilterById: action.payload || {}, };

    case types.FETCH_CAPS_DEMAND_FILTER_BY_ID_FAILURE:
      return { ...state, isCapsDemandFilterByIdLoading: false, capsDemandFilterByIdError: action.payload, };
        default:
            return state;
    }
}

export default matrixserviceReducer;